import { defineMessages } from 'react-intl';

export const sharedProjectBannerMessages = defineMessages({
  sharedBy: {
    defaultMessage: 'Shared by {owner} · view only',
    id: 'hwhxLUJH1w',
    description: 'Banner on a Work thread the current user can view but not edit',
  },
  sharedAnonymous: {
    defaultMessage: 'Shared with you · view only',
    id: 'a4RFkBqtcY',
    description:
      'Banner on a shared Work thread when the owner display name is unavailable',
  },
  continueInCopy: {
    defaultMessage: 'Continue in my own copy',
    id: 'ADUEF9zUKS',
    description: 'CTA for a grantee to fork a shared Work thread into their own copy',
  },
});
